import React, {useCallback, useState, useRef} from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import theme from '../../../../theme';
import ColorSelect from '../ColorSelect';
import {debounce} from 'lodash';
import trackAnalytics from '../../../../utils/gaia/trackAnalytics';
import {AreaPopupProps} from './index';
import PopupCloseButton from '../PopupCloseButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {getAreaRemoteId} from '../../../../utils/gaia/saveArea';
import useGetSyncPromise from '../../../../utils/react/useGetSyncPromise';
import AreaStats from '../../AreaStats';

const debouncedEditAreaAttributesEvent = debounce(edited => {
    trackAnalytics('Edit Area Attributes', {edited, category: 'map2'});
}, 1000, {leading: false, trailing: true});

export default function WritableAreaPopup({
    areaLocalId,
    areas,
    areaDispatcher,
    onPopupChange,
}: AreaPopupProps) {

    const area = areas[areaLocalId];
    const {notes, title, name, color} = area.properties;

    const getSyncPromise = useGetSyncPromise();
    const remoteId = getSyncPromise(getAreaRemoteId(area))[0];
    const pathname = remoteId && `/datasummary/area/${remoteId}/`;

    const [moreOpen, setMoreOpen] = useState<boolean>(false);
    const moreRef = useRef();

    return <div style={{width: 250, display: 'flex', flexDirection: 'column'}}>
        <PopupCloseButton onClick={useCallback(() => onPopupChange(undefined), [onPopupChange])} />
        <div style={{display: 'flex', flexDirection: 'row'}}>
            <TextField
                value={title === undefined ? name : title}
                label={'Area Title'}
                margin='dense'
                variant='outlined'
                onChange={(event: any) => {
                    debouncedEditAreaAttributesEvent('Title');
                    areaDispatcher({
                        type: 'update',
                        save: true,
                        area: {
                            ...area,
                            properties: {...area.properties, title: event.target.value}
                        }
                    });
                }}
                style={{flex: 1, marginRight: theme.spacing(1)}}
                inputProps={{maxLength: 500}}
            />
            <ColorSelect
                value={color}
                onChange={(event: any) => {
                    debouncedEditAreaAttributesEvent('Color');
                    areaDispatcher({
                        type: 'update',
                        save: true,
                        area: {
                            ...area,
                            properties: {...area.properties, color: event.target.value}
                        }
                    });
                }}
            />
        </div>

        <TextField
            label='Notes'
            margin='dense'
            multiline
            onChange={(event: any) => {
                debouncedEditAreaAttributesEvent('Notes');
                areaDispatcher({
                    type: 'update',
                    save: true,
                    area: {
                        ...area,
                        properties: {...area.properties, notes: event.target.value}
                    }
                });
            }}
            rows={2}
            rowsMax={10}
            value={notes}
            variant='outlined'
        />

        <div style={{
            display: 'flex',
            flexDirection: 'row',
            marginTop: theme.spacing(1),
            alignItems: 'flex-end',
        }}>
            <AreaStats area={area} style={{flex: 1}} />

            {(window.location.pathname !== pathname || area.properties.track_type === 'route') &&
                <div>
                    <Button
                        onClick={() => setMoreOpen(!moreOpen)}
                        variant='contained'
                        color='primary'
                        buttonRef={moreRef}
                        style={{fontSize: 12, color: '#fff'}}
                    >
                            More
                        <ExpandMoreIcon style={{width: 16, marginRight: -4, marginLeft: 2}} />
                    </Button>

                    <Menu
                        onClose={() => setMoreOpen(false)}
                        open={moreOpen}
                        anchorEl={moreRef.current}
                    >
                        {window.location.pathname !== pathname && <MenuItem
                            href={pathname}
                            style={{fontSize: 12}}
                            onClick={() => trackAnalytics('View Area Details', {
                                category: 'map2'
                            })}
                            component='a'
                            disabled={!pathname}
                        >
                                Open Details Page
                        </MenuItem>}


                        {window.location.pathname !== pathname && <MenuItem
                            onClick={() => {
                                trackAnalytics('Delete Area', {category: 'map2'});
                                areaDispatcher({type: 'remove', area, save: true});
                            }}
                            style={{fontSize: 12}}
                        >
                                Delete
                        </MenuItem>}
                    </Menu>
                </div>
            }
        </div>
    </div>;
}
